import React from 'react';
import {
    Layout,
    Row,
    Col,
    message,
    Modal
} from 'antd';
import TableWrapper from '../elements/TableWrapper';
import img from './../../assets/img/At the office-pana 1.png';
import MiCompAPI from '../../util/api';
import UpdateEnquiryRate from './UpdateEnquiryRate';
const { Content } = Layout;
class BrokerEnquiry extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                title: 'LOA',
                dataIndex: 'loa',
                sorter: (a, b) => a.loa.localeCompare(b.loa),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Carrier',
                dataIndex: 'carrier',
                sorter: (a, b) => a.carrier.localeCompare(b.carrier),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Plan',
                dataIndex: 'plan',
                sorter: (a, b) => a.plan.localeCompare(b.plan),
                sortDirections: ["descend", "ascend"]
            },

        ];
        this.columns_Inner = [
            {
                title: 'Enquiry',
                dataIndex: 'enqId',
                sorter: (a, b) => a.enqId.localeCompare(b.enqId),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Member',
                dataIndex: 'member',
                sorter: (a, b) => a.member.localeCompare(b.member),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Family Type',
                dataIndex: 'familyType',
                sorter: (a, b) => a.familyType.localeCompare(b.familyType),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Status',
                dataIndex: 'status',
                sorter: (a, b) => a.status.localeCompare(b.status),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: "Rate",
                dataIndex: 'rate',
                render: (text, record) => text && text !== "" && "$" + text
            },
            {
                title: "Action",
                render: (text, record) => {
                    return (
                        <div>
                            {record.status === "Initiated" && <i onClick={() => {

                                this.setState({
                                    addrate: true,
                                    id: record.id
                                })
                            }} className="fa fa-pencil fa-blue" ></i>}
                        </div>
                    );
                },
            }

        ];
        this.state = {
            BrokerEnquirys: [],
            addrate: false,
            id: 0,
            isLoading: false,
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount() {
        this.GetAllBrokerEnquiries();
    }
    addrateSubmitHandler = (data) => {

        this.api.invoke(
            "UpdateRate",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                        this.setState({
                            addrate: false
                        })
                        this.GetAllBrokerEnquiries();
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                } else {
                    message.destroy();
                    message.error("Add Rate failed. Contact Support", 3);
                }
            },
            data
        );
    };
    GetAllBrokerEnquiries() {
        this.setState({
            isLoading: true
        })
        this.api.invoke("GetAllBrokerEnquiries",
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            BrokerEnquirys: data.data,
                            isLoading: false
                        })
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            });
    }
    render() {
        return (
            <Content>
                {this.state.addrate ? (
                    <Modal
                        visible={this.state.addrate}
                    >
                        <UpdateEnquiryRate
                            closeDrawerHandler={() => {
                                this.setState({
                                    addrate: false
                                })
                            }}
                            id={this.state.id}
                            submitHandler={this.addrateSubmitHandler}
                            width={300} />
                    </Modal>
                ) : null}
                <div className="mi_main_div">
                    <div className="mi_box_sd">
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">Enquiries</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '150px', marginTop: '-50px' }} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <div className="div_TB">
                        <TableWrapper
                            expandedRowRender={(record) => (
                                <>
                                    <TableWrapper
                                        rowKey="member_id"
                                        data={record.brokerItems.map((x) => {
                                            return {
                                                ...x,
                                                rate: x.rate,
                                                enqId: x.enqId,
                                                member: x.member,
                                                familyType: x.familyType,
                                                status: x.status,
                                            };
                                        })}
                                        columns={this.columns_Inner}

                                    ></TableWrapper>
                                </>
                            )}
                            rowKey="id"
                            columns={this.columns}
                            data={this.state.BrokerEnquirys}
                            title="Enquiries"
                            buttons={this.tableButtons}
                            search={true}
                            loading={this.state.isLoading}
                        />
                    </div>
                </div>
            </Content>
        );
    }
}
export default BrokerEnquiry;